module.exports = "<router-outlet>\r\n\r\n</router-outlet>"